import { render } from "./NavBar.vue?vue&type=template&id=552d36bb&scoped=true"
const script = {}

import "./NavBar.vue?vue&type=style&index=0&id=552d36bb&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1621785964/src/bitbucket.org/hotelkey/hotelkeyapp.com-v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552d36bb"]])

export default __exports__